import { render, staticRenderFns } from "./ReceivershipTaskQueue.vue?vue&type=template&id=a514457c&scoped=true&"
import script from "./ReceivershipTaskQueue.vue?vue&type=script&lang=js&"
export * from "./ReceivershipTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./ReceivershipTaskQueue.vue?vue&type=style&index=0&id=a514457c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a514457c",
  null
  
)

export default component.exports